import { Tabs } from "antd";
import { createContext, useContext, useEffect, useState, type PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";

type WorkspaceMode = "entry" | "data";
const WorkspaceContext = createContext<{ mode: WorkspaceMode } | null>(null);
export const useOperationsWorkspace = () => useContext(WorkspaceContext);

export function OperationsTransactionWorkspace({ children }: PropsWithChildren) {
  const [mode, setMode] = useState<WorkspaceMode>("entry");
  const { pathname } = useLocation();

  // A transaction page must always open on its entry form. The workspace can be
  // reconciled across sibling routes, so explicitly discard the previous page's tab.
  useEffect(() => setMode("entry"), [pathname]);
  return <WorkspaceContext.Provider value={{ mode }}>
    <Tabs className="operations-entry-data-tabs" type="card" activeKey={mode} onChange={(key) => setMode(key as WorkspaceMode)} items={[{ key: "entry", label: "Entry" }, { key: "data", label: "Data" }]} />
    <div className={`operations-workspace operations-workspace-${mode}`}>{children}</div>
  </WorkspaceContext.Provider>;
}
